var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecureMessaging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 228,
    viewBox: "0 0 228 228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 228,
    height: 228,
    rx: 35,
    fill: "#00B8E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.3333 140.666H90.6667V137.33H87.3333V140.666ZM87.3333 160.664H84C84 161.928 84.7131 163.083 85.8421 163.648C86.9712 164.213 88.3223 164.091 89.3325 163.333L87.3333 160.664ZM114 140.666V137.33H112.889L112.001 137.997L114 140.666ZM94 90.6655H90.6667V97.3363H94V90.6655ZM134 97.3363H137.333V90.6655H134V97.3363ZM94 110.665H90.6667V117.335H94V110.665ZM120.667 117.335H124V110.665H120.667V117.335ZM84 140.666V160.664H90.6667V140.666H84ZM89.3325 163.333L115.999 143.335L112.001 137.997L85.3341 157.996L89.3325 163.333ZM114 144.001H154V137.33H114V144.001ZM154 144.001C159.525 144.001 164 139.53 164 133.999H157.333C157.333 135.841 155.848 137.33 154 137.33V144.001ZM164 133.999V74.0017H157.333V133.999H164ZM164 74.0017C164 68.4709 159.525 64 154 64V70.6707C155.848 70.6707 157.333 72.1593 157.333 74.0017H164ZM154 64H74V70.6707H154V64ZM74 64C68.4745 64 64 68.4709 64 74.0017H70.6667C70.6667 72.1593 72.1521 70.6707 74 70.6707V64ZM64 74.0017V133.999H70.6667V74.0017H64ZM64 133.999C64 139.53 68.4745 144.001 74 144.001V137.33C72.1521 137.33 70.6667 135.841 70.6667 133.999H64ZM74 144.001H87.3333V137.33H74V144.001ZM94 97.3363H134V90.6655H94V97.3363ZM94 117.335H120.667V110.665H94V117.335Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureMessaging);
export default __webpack_public_path__ + "static/media/SecureMessaging.0c2fab271cb3ac4c206062c7ba9ab286.svg";
export { ForwardRef as ReactComponent };